import {combineReducers, Reducer} from '@reduxjs/toolkit'

import {routerReducer} from '@web/slices/router'

import {ApplyRootState as RootState} from '../../interfaces'
import common from '../../slices/common'
import fds from '../../slices/fds'
import shoppingSubscription from '../../slices/shoppingSubscription'

const createRootReducer = (): Reducer<RootState> =>
    combineReducers({
        common,
        fds,
        router: routerReducer,
        shoppingSubscription,
    })

export default createRootReducer
